import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-4">
                做爱指南
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                从科学、健康与情感角度深度解析亲密关系，帮助成年伴侣提升生活质量，建立更深的联结。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-3">
                内容分类
              </h4>
              <ul className="flex flex-col gap-2">
                <li>
                  <Link to="/category/sexual-health" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    性健康基础
                  </Link>
                </li>
                <li>
                  <Link to="/category/intimacy-relationship" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    亲密关系经营
                  </Link>
                </li>
                <li>
                  <Link to="/category/techniques-methods" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    性技巧与方法
                  </Link>
                </li>
                <li>
                  <Link to="/category/psychology-emotion" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    心理与情感
                  </Link>
                </li>
                <li>
                  <Link to="/category/couple-communication" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    两性沟通
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-3">
                热门文章
              </h4>
              <ul className="flex flex-col gap-2">
                <li>
                  <Link to="/article/understanding-sexual-response-cycle" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    性反应周期的四个阶段
                  </Link>
                </li>
                <li>
                  <Link to="/article/building-emotional-intimacy" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    深度亲密关系的五个层次
                  </Link>
                </li>
                <li>
                  <Link to="/article/importance-of-foreplay" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    前戏的科学
                  </Link>
                </li>
                <li>
                  <Link to="/article/overcoming-sexual-anxiety" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    走出性焦虑
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-3">
                关于我们
              </h4>
              <ul className="flex flex-col gap-2">
                <li>
                  <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    品牌介绍
                  </Link>
                </li>
                <li>
                  <Link to="/about#contact" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    联系我们
                  </Link>
                </li>
              </ul>
              <div className="flex items-center gap-3 mt-4">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 hover:bg-primary-100 hover:text-primary-600 transition-colors" aria-label="微信">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 hover:bg-primary-100 hover:text-primary-600 transition-colors" aria-label="微博">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 hover:bg-primary-100 hover:text-primary-600 transition-colors" aria-label="邮箱">
                  <i className="ri-mail-line text-sm"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row justify-between items-center gap-3">
            <p className="text-xs text-foreground-500">
              &copy; 2026 做爱指南. 本站内容仅供成年读者参考，不构成医疗建议。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors">使用条款</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}